import { createAsyncThunk } from "@reduxjs/toolkit";
import apiInstance from "../../config/api";

export const signup = createAsyncThunk("auth/signup", async (formData) => {
  try {
    const request = await apiInstance.post("/api/user/signup", formData);
    const response = request.data;

    if (response.status === "success") {
      return response.data;
    } else {
      throw new Error(response.message);
    }
  } catch (error) {
    throw new Error(error.message);
  }
});

export const login = createAsyncThunk("auth/login", async (data) => {
  try {
    const request = await apiInstance.post("/api/user/login", data);
    const response = request.data;
    if (response.status === "success") {
      // console.log(response.user);
      return response;
    } else {
      throw new Error(response.message);
    }
  } catch (error) {
    throw new Error(error.message);
  }
});

// Accepts either a raw Google credential string (existing call sites) or
// { token, dob } once a first-time Google signup needs to supply a date of
// birth (the backend now requires it for new Google accounts, same as local
// signup already does).
export const googleLogin = createAsyncThunk("auth/google-login", async (payload) => {
  const { token, dob } = typeof payload === "string" ? { token: payload } : (payload ?? {});
  try {
    const request = await apiInstance.post("/api/user/auth/google", dob ? { token, dob } : { token });
    const response = request.data;

    if (response.status === "success") {
      return response;
    } else {
      throw new Error(response.message);
    }
  } catch (error) {
    throw new Error(error.message);
  }
});

export const sendotp = createAsyncThunk('auth/otp', async (data) => {
  try {

    const request = await apiInstance.put("/api/user/otp", data);
    const response = request.data;
    if (response.status === 'success') {
      return response
    }
    else {
      throw new Error(response.message)
    }
  }
  catch (error) {
    throw new Error(error.message)
  }
})

export const verifyloginOtp = createAsyncThunk('auth/login-otp', async (data) => {
  try {
    const request = await apiInstance.post("/api/user/verify/verifyLogin", data);
    const response = request.data;
    if (response.status === 'success') {
      return response;
    }
    else {
      throw new Error(response.message)
    }
  }
  catch (error) {
    throw new Error(error.message)
  }
})


export const verifyotp = createAsyncThunk('auth/verify-otp', async (data) => {
  try {
    const request = await apiInstance.post("/api/user/verifyotp", data);
    const response = request.data
    if (response.status === 'success') {
      return response
    }
    else {
      throw new Error(response.message)
    }
  }
  catch (error) {
    throw new Error(error.message)
  }
})

export const resetPassword = createAsyncThunk('auth/reset-password', async (data) => {
  try {
    const request = await apiInstance.put("/api/user/passwordrecovery", data)
    const response = request.data

    if (response.status === 'success') {
      return response
    }
    else {
      throw new Error(response.message)
    }
  }
  catch (error) {
    throw new Error(error.message)
  }
})

export const verifyAccount = createAsyncThunk('auth/account-verify', async (data) => {
  try {
    const request = await apiInstance.post("/api/user/verify/verify/AccountIdentity", data);
    const response = request.data
    console.log('verify account API: ', response)
    if (response.status === 'success') {
      return response
    }
    else {
      throw new Error(response.message)
    }
  }
  catch (error) {
    console.log('verify account API error: ', error.message)
    throw new Error(error.message)
  }
})

export const logout = createAsyncThunk('auth/logout', async (socketId) => {
  try {
    const request = await apiInstance.post(`/api/user/logout/${socketId}`);
    const response = request.data
    if (response.status === 'success') {
      return true
    }
    else {
      throw new Error(response.message)
    }
  }
  catch (error) {
    throw new Error(error.message)
  }
})